import React from 'react';

const TotalLeadsSVG = ({ color = 'black', className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='33'
      height='25'
      viewBox='0 0 33 25'
      fill='none'
      className={className}
    >
      <path
        d='M22.3555 3.58813C22.8068 3.42081 23.2948 3.32941 23.8044 3.32941C26.1065 3.32941 27.9727 5.19569 27.9727 7.49785C27.9727 9.8 26.1065 11.6663 23.8044 11.6663C23.2948 11.6663 22.8068 11.5749 22.3555 11.4075'
        stroke='#0744E1'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M1.25 23.3379C2.40274 19.491 5.36827 18.3358 12.0876 18.3358C18.807 18.3358 21.7725 19.491 22.9253 23.3379'
        stroke='#0744E1'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M24.582 16.6684C28.5886 16.8268 30.4664 17.7327 31.2513 20.0032'
        stroke='#0744E1'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M17.9604 7.49781C17.9604 10.7208 15.3477 13.3336 12.1247 13.3336C8.90177 13.3336 6.28906 10.7208 6.28906 7.49781C6.28906 4.27477 8.90177 1.66199 12.1247 1.66199C15.3477 1.66199 17.9604 4.27477 17.9604 7.49781Z'
        stroke='#0744E1'
        strokeWidth='2'
      />
    </svg>
  );
};

export default TotalLeadsSVG;
